// extracted by mini-css-extract-plugin
export default {"container":"complaintadd_container__Djdcs","header":"complaintadd_header__L3jNu"};